__turbopack_context__.v({
  "--is-photo-voting": "animation-linear-fade-module-scss-module__xtcdya__--is-photo-voting",
  "--is-showing-interstitial-ad": "animation-linear-fade-module-scss-module__xtcdya__--is-showing-interstitial-ad",
  "animation-container": "animation-linear-fade-module-scss-module__xtcdya__animation-container",
});
